<div class="page_title">
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <app-custom-breadcrumb *ngIf="customData" [data]="customData"></app-custom-breadcrumb>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid">
  <div class="pages_space">
    <div class="row">
      <div class="col-12 col-sm-auto">
        <div class="card_claimInfo_wrap">

          <div class="row">
            <div class="col-12" style="margin-top: 5px;">
              <k-card [card]="claimInfo" *ngIf="claimData.length !=0"></k-card>
            </div>
          </div>

          <div class="row">
            <div class="col-12" style="margin-top: 5px;">
              <k-card [card]="claimInfo2" *ngIf="claimData.length !=0"></k-card>
            </div>
          </div>


          <button type="button" class="btn-dark-grey klaim_btn btn-block text-center mt-2 w-100"
            (click)="confirmDeleteClaim(confirmDeleteClaimModal)" *ngIf="claimData.length !=0 && isDeleteClaimsAllowed">
            Delete Claim
          </button>


          <div class="row">
            <div class="col-12">
            </div>
          </div>
        </div>

      </div>
      <div class="col-12 col-sm">

        <k-tabs class="analyticsTab ">
          <k-tab [label]="'Tasks'" [extraClass]="'tab-tasks'" [active]="this.tabTasks">
            <div *ngFor="let workflow of this.workflowData">
              <h4>{{workflow['workFlowNodeName']}}</h4>
              <div class="row">
                <!-- Loop -->
                <div class="col-12 col-lg-6 col-xl-3 iQcard_col" *ngFor="let task of workflow['tasks']">
                  <div class="card iQcard item-hover-effect">
                    <div class="iQcard_header">
                      <div class="row">
                        <div class="col">
                          <div class="headerTitle">{{task['taskName']}}</div>
                        </div>
                        <div class="col-auto pl-0">

                        </div>
                      </div>
                    </div>
                    <div class="iQcard_body pt-0">
                      <div class="row">
                        <div class="col">
                          <p class="completedStatus" *ngIf="task['status']=='completed'">
                            <b>{{task['status'].charAt(0).toUpperCase() + task['status'].slice(1)}}</b>
                          </p>
                        </div>
                        <div class="col-auto" *ngIf="task['status']=='incomplete'">
                          <k-button [type]="KButtonType.KLAiMSButton" [label]="'Edit'" [color]="'brand-main'"
                            (buttonClick)="taskAction(task,this.claimId)">
                          </k-button>
                        </div>
                        <div class="col-auto" *ngIf="task['status']=='todo'">
                          <k-button [type]="KButtonType.KLAiMSButton" [label]="'Initiate'" [color]="'brand-main'"
                            (buttonClick)="taskAction(task,this.claimId)">
                          </k-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Loop End -->
              </div>
            </div>

          </k-tab>
          <k-tab [label]="'Medical Records'" [extraClass]="'tab-medical'" [active]="this.tabMedical">
            <ng-container
              *ngIf="this.claimData?.claimant?.condition == 'Noise Induced Hearing Loss' && this.createAudiometryTaskId!= ''">
              <div class="row">
                <div class="col-12">
                  <div class="pages_space">
                    <div class="row mb-2">
                      <div class="col-12 col-md">
                        <!-- search placeholder -->
                        <form name="searchMedicalRecordsFilterForm" [formGroup]="searchMedicalRecordsFilterForm"
                          #formDir="ngForm">
                          <div class="row search_section">
                            <div class="col col-md-6 col-lg-4 col-xl-3 pr-lg-0">
                              <input type="text" class="form-control rounded-0" formControlName="keyword"
                                placeholder="Search" />
                            </div>
                            <div class="col-auto ">
                              <div class="k_button_holder">
                                <k-button [type]="KButtonType.KLAiMSButton" [label]="'Search'" [color]="'brand-main'"
                                  (buttonClick)="submitSearchMedicalRecordsFilterForm($event, searchMedicalRecordsFilterForm)">
                                </k-button>
                                <k-button [type]="KButtonType.KLAiMSButton" [color]="'brand-main'"
                                  [icon]="{type: 'fas', name: 'undo'}"
                                  (buttonClick)="resetSearchMedicalRecordsFilterForm(searchMedicalRecordsFilterForm)">
                                </k-button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                      <div class="col-12 col-md-auto mt-2 mt-md-0 text-end">
                        <k-button [type]="KButtonType.KLAiMSButton" [label]="'Create New Test'" [color]="'brand-main'"
                          [icon]="{type: 'fas', name: 'plus'}" (buttonClick)="createNewNIHLTest()">
                        </k-button>
                      </div>
                    </div>

                    <div class="mt-3">
                      <h4>Audiometry Tests</h4>
                      <div *ngIf="this.allAudiometryTests.length == 0">
                        <p>No Data found</p>
                      </div>
                    </div>


                    <div class="row">
                      <!-- Loop -->
                      <div class="col-12 col-lg-6 col-xl-3 iQcard_col" *ngFor="let test of this.allAudiometryTests">
                        <div class="card iQcard item-hover-effect" (click)="viewAudiogram($event, test)">
                          <div class="iQcard_header">
                              <div class="row">
                                <div class="col">

                                  <div class="headerTitle" title="Employer">{{test['type']}}</div>
                                </div>
                                <div class="col-auto pl-0">
                                  <ul class="card_more_dropdown float-right">
                                    <li>
                                      <a>
                                        <k-icon class="kebab_menu"
                                          [icon]="{type: 'image', src: './../assets/images/more.svg'}"></k-icon>
                                      </a>
                                      <ul>
                                        <li (click)="editAudiogram($event, test)" *ngIf="!test['audiometryType']">
                                          Edit
                                        </li>
                                        <li (click)="viewAudiogram($event, test)">
                                          View
                                        </li>
                                        <li *ngIf='isDeleteMedReportsAllowed'
                                          (click)="confirmDeleteNIHLTest($event, test)">
                                          Delete
                                        </li>
                                      </ul>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                          </div>
                          <div class="iQcard_body pt-0">
                            <p class="mb-0" title="Audiogram date">
                              {{test['audiogramDate'] | date:'dd/MM/yyyy'}}
                            </p>

                          </div>
                        </div>
                      </div>
                      <!-- Loop End -->
                    </div>


                  </div>
                  <!-- </div> -->
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="this.claimData?.claimant?.condition == 'Carcinoma of the Lung'">
              <app-claim-medical [claimId]="this.claimId"
                [claimUsecaseName]="'carcinoma-of-the-lung'"></app-claim-medical>
            </ng-container>

            <ng-container *ngIf="this.claimData?.claimant?.condition == 'Mesothelioma'">
              <app-claim-medical [claimId]="this.claimId" [claimUsecaseName]="'mesothelioma'"></app-claim-medical>
            </ng-container>

            <ng-container *ngIf="this.claimData?.claimant?.condition == 'Asbestosis'">
              <app-claim-medical [claimId]="this.claimId" [claimUsecaseName]="'asbestosis'"></app-claim-medical>
            </ng-container>

            <ng-container *ngIf="this.claimData?.claimant?.condition == 'Pleural Thickening'">
              <app-claim-medical [claimId]="this.claimId" [claimUsecaseName]="'pleural-thickening'"></app-claim-medical>
            </ng-container>

          </k-tab>

          <k-tab [label]="'Documents'">
            <ng-container
              *ngIf="this.claimData?.claimant?.condition == 'Noise Induced Hearing Loss' && this.createAudiometryTaskId!= ''">
              <app-documents [claimId]="this.claimId"></app-documents>
            </ng-container>
            <div class="row">
              <div class="col-12">

              </div>
            </div>
          </k-tab>
          <k-tab [label]="'Outcome'" [extraClass]="'tab-outcome'" [active]="this.tabOutcome">
            <div
              *ngIf="selectedTabs.length == 0  && this.claimData?.claimant?.condition == 'Noise Induced Hearing Loss'">
              <h4>Assess Disability</h4>
              <p>Create atleast 1 Audiometry Test to show available task(s)</p>
            </div>
            <div *ngFor="let tab of selectedTabs">
              <ng-container *ngIf="tab == 'outcome'">
                <app-claim-outcome [claimId]="this.claimId"></app-claim-outcome>
              </ng-container>
            </div>
          </k-tab>
        </k-tabs>




      </div>
    </div>
  </div>
</div>
<k-modal [overlay]="true" [id]="'deleteClaimModal'">
  <k-modal-header [dismiss]="true" [backgroundColor]="'brand-main'">
    <strong>Confirm</strong>
  </k-modal-header>
  <k-modal-body>
    <div class="row">
      <div class="col-sm-12">
        <div class="text">
          Delete {{this.claimData?.claimant?.claimantName + "'s"}} {{this.claimData?.claimant?.condition}} claim? This
          cannot be undone.
        </div>

      </div>
    </div>
  </k-modal-body>
  <k-modal-footer>
    <k-button [type]="KButtonType.KLAiMSButton" [label]="'Delete'" [color]="'brand-main'"
      (buttonClick)="deleteClaim()"></k-button>
    <k-button [type]="KButtonType.KLAiMSButton" [label]="'Cancel'" [subType]="KKcgButtonSubType.Cancel"
      [color]="'dark-grey'" (buttonClick)="closeDeleteClaimModal()"></k-button>
  </k-modal-footer>
</k-modal>

<k-modal [overlay]="true" [id]="'deleteNIHLTestModal'">
  <k-modal-header [dismiss]="true" [backgroundColor]="'brand-main'">
    <strong>Confirm</strong>
  </k-modal-header>
  <k-modal-body>
    <div class="row">
      <div class="col-sm-12">
        <div class="text">
          Delete {{this.claimData?.claimant?.claimantName + "'s"}} NIHL Test taken on {{this.selectedTest.audiogramDate
          | date:'dd/MM/yyyy'}} ? This
          cannot be undone.
        </div>

      </div>
    </div>
  </k-modal-body>
  <k-modal-footer>
    <k-button [type]="KButtonType.KLAiMSButton" [label]="'Delete'" [color]="'brand-main'"
      (buttonClick)="deleteNIHLTest()"></k-button>
    <k-button [type]="KButtonType.KLAiMSButton" [label]="'Cancel'" [subType]="KKcgButtonSubType.Cancel"
      [color]="'dark-grey'" (buttonClick)="closeDeleteNIHLTestModal()"></k-button>
  </k-modal-footer>
</k-modal>

<!-- Modal NIHL Audiometry Test Delete Confirm-->
<ng-template #confirmDeleteTest let-modal>
  <div class="modal-header">
    <h5 class="modal-title ">Confirm </h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="px-3">
      <p>Delete {{this.claimData?.claimant?.claimantName}}'s NIHL Test of type: {{this.selectedTest.type}} taken on
        {{this.selectedTest.audiogramDate| date:'dd/MM/yyyy'}}? This cannot be undone.</p>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn-dark-grey klaim_btn text-center" (click)="modal.close('Cancel click')">
      Cancel</button>
    <button type="button" class="btn-brand-main klaim_btn text-center" (click)="this.deleteNIHLTest()">
      OK</button>
  </div>
</ng-template>
<!-- Modal End  NIHL Audiometry Test Delete Confirm-->

<!-- Modal Delete Claim -->
<ng-template #confirmDeleteClaimModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title ">Confirm </h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="px-3">
      <p>Delete {{this.claimData?.claimant?.claimantName + "'s"}} {{this.claimData?.claimant?.condition}} claim? This
        cannot be undone.</p>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn-dark-grey klaim_btn text-center" (click)="modal.close('Cancel click')">
      Cancel</button>
    <button type="button" class="btn-brand-main klaim_btn text-center" (click)="this.deleteClaim()">
      OK</button>
  </div>
</ng-template>
<!-- Modal End Delete Claim -->

<k-simple-alert [display]="displaySuccess" [msgType]="'success'" [message]="successText"
  [timeout]="timeout"></k-simple-alert>
<k-simple-alert [display]="displayError" [msgType]="'error'" [message]="errorText" [timeout]="timeout"></k-simple-alert>